import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeIntelligenceKitProvider } from 'breeze-intelligence-kit/components/BreezeIntelligenceKitProvider';
import { UpgradeLink } from '../UpgradeLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EnrichmentActionsTooltip = ({
  canUpgrade = false,
  upgradeSource
}) => {
  const Tooltip = () => {
    if (canUpgrade) {
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.actions.enrichRecords"
        }), ' ', /*#__PURE__*/_jsx(UpgradeLink, {
          upgradeSource: upgradeSource,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.actions.enrichRecordsCTA"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentProperties.permissions.noAccessManualContactAdmin"
    });
  };
  return /*#__PURE__*/_jsx(BreezeIntelligenceKitProvider, {
    children: /*#__PURE__*/_jsx(Tooltip, {})
  });
};